import { picklistOptionOptions } from './../../../../models/picklistOption';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
// import { ImportService } from 'src/app/_services/import';
import { FileToImport } from '~/front-models/fileToImport';
import { AccountSite } from '~/models/administration/accountSite';
import { UserSummary } from '~/models/administration/user';
import { ImportService } from '~/services/modules/stocks/import';
import { SecurityService } from '~/services/security.service';
import { ImportComponent } from '../import.component';
import { finalize } from 'rxjs/operators';
import { UrlHandlingStrategy } from '@angular/router';
@Component({
    selector: 'stocks-import-send-data',
    templateUrl: './send-data.html',
    styleUrls: ['../import.scss'],
    animations: [
        trigger('textChanges', [
            state('void', style({ opacity: 0 })),
            state('*', style({ opacity: 1 })),
            transition('void => *', [animate('0.5s 0.5s ease-in')]),
            transition('* => void', [animate('0.5s ease-in')]),
        ]),
    ],
    host: {
        class: 'stocks-import-send-data',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportSendDataComponent implements OnInit {
  _selectedModel: FileToImport;
  _importAccounts: AccountSite[];
  _importedSuccessfully: number;
  _failedToimport: number;
  _accountsImported = 0;
  _messageToDisplay: string;
  _importStatus: 'Importing files...' | 'Almost done...' | 'Done!' | 'Failed!';
  _successAccountsCount = 0;
  _failureAccountsCount = 0;
  _running: any;
  _gridColumnsName: any[] = [];
  _resultGrids: any[] = [];
  _pageSize = 10;
  _skip = 0;
  _currentUser: UserSummary;
  _dataCount: number;
  _resultsGridDataColumns: any[] = [];
  private messages = [
    "Don't close this page, this will take a while",
    'Sit back and relax',
  ];

  constructor(
    private _importService: ImportService,
    private _importComponent: ImportComponent,
    private _securityService: SecurityService
  ) {
    this._currentUser = this._securityService.currentUser;
  }

  ngOnInit() {
    this._selectedModel = this._importComponent.selectedModel;
    this._importAccounts = this._importComponent.importAccounts;




    // Fill grid columns name if mappedName exists
    this._selectedModel.columns.forEach((element) => {
      if (element.mappedNameToValidate) {
        this._gridColumnsName.push({
          entity: element.entity,
          entityRelation: element.entityRelation,
          label: element.label,
          mappedName: element.mappedName,
          required: element.required,
          name: element.name,

          type: element.type,
          relatedDbField: element.relatedDbField,
          fieldName: element.fieldName,

          isCustomField: element.isCustomField,
          Path: !element.entity ? element.name :
            element.entity && !element.fieldName ? element.entity + "." + element.name
              : element.entity && element.fieldName ? element.entity + "." + element.name + "." + element.fieldName : ""
        });

      }
    });
    this._gridColumnsName.push({
      name: 'Error',
      type: '',
    });
    //

    this.changeDisplayText();
    this.startProgress();
    this.submitDataPerAccount();
  }

  assign(obj: any, keyPath: any, value: any) {
    let lastKeyIndex = keyPath.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
      let key = keyPath[i];
      if (!(key in obj)) {
        obj[key] = {}
      }
      obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
  }

  ReCreateListWithCorrectObject(List: any) {
    var CorrectList = [];

    for (var i = 0; i < List.length; i++) {
      var TempObject: any = {};
      var ColumnNames = Object.keys(List[i]);
      for (var x = 0; x < ColumnNames.length; x++) {
        let ColumnName = ColumnNames[x];
        let CheckIfObject = ColumnName.split(".");
        this.assign(TempObject, CheckIfObject, List[i][ColumnName]);
      }
      CorrectList.push(TempObject);
    }
    return CorrectList;

  }
  ImportErrors: any = [];
  // recursive function
  MappedPropertiesInExcel: any = [];
  private submitDataPerAccount() {
    this.startProgress();
    this._importStatus = 'Importing files...';
    // this._importComponent.importObject.accountSite = this._importAccounts[
    //   this._accountsImported
    // ];
    this._importComponent.importObject.accountSites = this._importAccounts;
    this._importComponent.importObject.accountIds = this._importAccounts;
    this._importComponent.importObject.MappedExcelColumns = this.getExcelPropertyNames();
    var customFieldsDateGrids = this._gridColumnsName.filter(x => x.isCustomField == true && x.type == "date");
    customFieldsDateGrids.forEach(grid => {
      this._importComponent.importObject.dataToImport.forEach((data: any) => {
        var DataOfColumn;
        data.customFieldsValue.forEach((customFieldData: any) => {
          if (this.isDateType(customFieldData[grid.name])) // Type Date
          {
            if (customFieldData[grid.name])
              customFieldData[grid.name] = customFieldData[grid.name].toISOString();
          }
          else if (this.convertStringToDate(customFieldData[grid.name])) // Type String
          {
            if (customFieldData[grid.name]) {
              customFieldData[grid.name] = this.convertStringToDate(customFieldData[grid.name]);
              customFieldData[grid.name] = customFieldData[grid.name] ? customFieldData[grid.name].toISOString() : null;
            }
          }


        });







      });
    });
    this._importService
      .import(this._selectedModel.labelName, this._importComponent.importObject, this._importComponent.isAsset)
      .pipe(finalize(() => this.stopProgress()))
      .subscribe((data: any) => {
        this.ImportErrors = [];
        if (this._currentUser.isEnterprise) {
          //#region Old EnterPrise Handling
          // if (data) {
          //   this._failureAccountsCount++;
          //   if (data.unitOfMeasureAccounts != null && data.unitOfMeasureAccounts[0] != null && data.unitOfMeasureAccounts[0].account != null && data.unitOfMeasureAccounts[0].account.name != null) {
          //     this._resultGrids.push({
          //       account: data.unitOfMeasureAccounts[0].account.name,
          //     });
          //     this.generateDataForGrid(
          //       data,
          //       data.unitOfMeasureAccounts[0].account.name
          //     );
          //   }
          // } else {
          //   this._successAccountsCount++;
          // }

          // this._accountsImported++;

          // if (this._accountsImported === this._importAccounts.length - 1) {
          //   this._importStatus = 'Almost done...';
          // }

          // if (this._accountsImported < this._importAccounts.length) {
          //   //this.submitDataPerAccount();
          //   // let ErrorObj = { message : "ImportErrors"};
          //   // this.ImportErrors.push(ErrorObj);
          //   //this.stopProgress();
          // } else {
          //   this._importStatus = 'Done!';
          //   //this.stopProgress();
          // }
          //#endregion
          //#region New EnterPrise Handling
          this._importStatus = 'Done!';

          if (data) {
            this._successAccountsCount = data.data.successAccountsCount;
            this._failureAccountsCount = data.data.failedAccountsCount;
            if (data.extraData) {
              this._resultsGridDataColumns = [];
              this._resultsGridDataColumns.push({
                field: this._selectedModel.labelName == "stockItems"
                  || this._selectedModel.labelName == "models"
                  ? "number"
                  : this._selectedModel.labelName == "addresses" ? "name"
                    : this._selectedModel.labelName == "assettypes" ? "modelType"
                      : this._selectedModel.labelName == "assets" ? "assetNumber"
                        : "code"
                ,
                title: this._selectedModel.labelName == "stockItems"
                  || this._selectedModel.labelName == "models"
                  ? "Number"
                  : this._selectedModel.labelName == "addresses" ? "Address Name"
                    : this._selectedModel.labelName == "assettypes" ? "Model Type"
                      : this._selectedModel.labelName == "assets" ? "Asset Number"
                        : "code"
              }, {
                field: "message",
                title: "Message"
              });
              data.extraData.forEach((element: any) => {
                if (!this._resultGrids.find(x => x.account == element.accountName)) {
                  this._resultGrids.push({
                    account: element.accountName,
                  });
                }
                var dataFilteredByAccount = data.extraData.filter((x: any) => x.accountName === element.accountName);

                // this._resultGrids.find((x) => x.account === element.accountName)[
                //   'data'
                // ] = dataFilteredByAccount;
                this._resultGrids.find((x) => x.account === element.accountName)['grid'] = {
                  data: dataFilteredByAccount.slice(this._skip, this._skip + this._pageSize),
                  total: dataFilteredByAccount.length,
                };
                // this.generateDataForGrid(
                //   data,
                //   element.accountName,
                // );
              });
            }


          }
        }
        else {
          if (data) {
            this._dataCount = data.length;
          }
          this._accountsImported++;

          if (this._accountsImported === this._importAccounts.length - 1) {
            this._importStatus = 'Almost done...';
          }

          if (this._accountsImported < this._importAccounts.length) {
            this.submitDataPerAccount();
            let ErrorObj = { message: "ImportErrors" };
            this.ImportErrors.push(ErrorObj);
            //this.stopProgress();
          } else {
            //this.ImportErrors = [];
            if (data)
              this.ImportErrors = data.filter((x: any) => x.message != null && x.message != "Saved successfully" && x.message != "Added successfully");

            this._importStatus = 'Done!';
            // this.stopProgress();
          }
        }
      }, (err: any) => {
        this._importStatus = 'Failed!';
        let ErrorObj = { message: "ImportErrors" };
        this.ImportErrors.push(ErrorObj);
        this.stopProgress();
      });
  }
  //#region Date Validate
  isDateType(date: any) {
    if (date) {
      if (Object.prototype.toString.call(date) === "[object Date]") {
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    else
      return false;

  }
  convertStringToDate(dateString: string): Date | null {
    // List of date format patterns to check
    const dateFormats = [
      'yyyy-MM-dd',
      'yyyy/MM/dd',
      'MM-dd-yyyy',
      'MM/dd/yyyy',
      'dd-MM-yyyy',
      'dd/MM/yyyy',
      'yyyy-MM-dd HH:mm:ss',
      'yyyy/MM/dd HH:mm:ss',
      'MM-dd-yyyy HH:mm:ss',
      'MM/dd/yyyy HH:mm:ss',
      'dd-MM-yyyy HH:mm:ss',
      'dd/MM/yyyy HH:mm:ss',
      // Add more formats as needed
    ];

    for (const format of dateFormats) {
      const parsedDate = this.parseDate(dateString, format);
      if (parsedDate !== null) {

        // const customDateFormat = this._dateFormtatPipe.transform(parsedDate);;
        // return  customDateFormat;
        return parsedDate;
      }
    }

    return null; // No valid format found
  }
  parseDate(dateString: string, format: string): Date | null {
    if (typeof dateString === 'string') {
      const parts = dateString.split(/[-/]/);
      const formatParts = format.split(/[-/]/);

      if (parts.length !== formatParts.length) {
        return null; // Invalid number of date parts
      }

      const dateValues: { [key: string]: number } = {};

      for (let i = 0; i < formatParts.length; i++) {
        const formatPart = formatParts[i];
        const value = parseInt(parts[i], 10);

        if (isNaN(value)) {
          return null; // Invalid numeric value
        }

        dateValues[formatPart] = value;
      }

      // Check if the parsed date is valid (basic range checks)
      if (
        dateValues['yyyy'] < 0 ||
        dateValues['MM'] < 1 ||
        dateValues['MM'] > 12 ||
        dateValues['dd'] < 1 ||
        dateValues['dd'] > 31
      ) {
        return null;
      }

      // Create a Date object
      return new Date(
        dateValues['yyyy'],
        dateValues['MM'] - 1, // Month is 0-based in JavaScript
        dateValues['dd']
      );
    }
    else
      return null;

  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  //#endregion
  private generateDataForGrid(data: any, accountName: string) {
    const datatoShow = this._importComponent.importObject.dataToImport;

    for (let i = 0; i < datatoShow.length; i++) {
      if (data[i].message) {
        datatoShow[i]['Error'] = data[i].message;
      }
    }

    this._resultGrids.find((x) => x.account === accountName)[
      'data'
    ] = datatoShow;

    this._resultGrids.find((x) => x.account === accountName)['grid'] = {
      data: datatoShow.slice(this._skip, this._skip + this._pageSize),
      total: datatoShow.length,
    };
  }

  private loadItems(accountName: string) {
    const datatoShow = this._resultGrids.find((x) => x.account === accountName)
      .data;

    this._resultGrids.find((x) => x.account === accountName).grid = {
      data: datatoShow.slice(this._skip, this._skip + this._pageSize),
      total: datatoShow.length,
    };
  }

  _pageChange(event: PageChangeEvent, accountName: string): void {
    this._skip = event.skip;
    this.loadItems(accountName);
  }

  private startProgress() {
    this._running = setInterval(() => {
      this.changeDisplayText();
    }, 6000);
  }

  private stopProgress() {
    this._messageToDisplay = '';
    if (this._running) {
      clearInterval(this._running);
      this._running = null;
    }
  }

  private changeDisplayText() {
    this._messageToDisplay = this.messages.find(
      (x) => x !== this._messageToDisplay
    );
  }
  getExcelPropertyNames() {
    var propertyNames: any = [];
    var propertyName = '';
    this._gridColumnsName.forEach(grid => {
      if (!grid.entity)
        propertyName = grid.name;
      else {

        if (grid.entityRelation == "OneToOne" || grid.entityRelation == "OneToMany") {
          if (grid.relatedDbField)
            propertyName = grid.relatedDbField;
          else {
            if (!grid.fieldName)
              propertyName = grid.entity + "." + grid.name;
            else
              propertyName = grid.entity + "." + grid.name + "." + grid.fieldName;
          }

        }
        // if(grid.entityRelation == "OneToMany")
        // {
        //   if(!grid.fieldName)
        //   propertyName = data[grid.entity][0][grid.name];
        //   else
        //   propertyName = data[grid.entity][0][grid.name][grid.fieldName];
        // }
      }
      propertyNames.push(propertyName);
    });
    return propertyNames;
  }
}
